import { render, staticRenderFns } from "./MultiPlots.vue?vue&type=template&id=39ab1513&scoped=true&"
import script from "./MultiPlots.vue?vue&type=script&lang=js&"
export * from "./MultiPlots.vue?vue&type=script&lang=js&"
import style0 from "./MultiPlots.vue?vue&type=style&index=0&id=39ab1513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ab1513",
  null
  
)

export default component.exports